import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Colors from '../common/NekoTheme';

const Page = Styled.div`
  background-color: ${Colors.white};
  background: #f1f1f1;
  margin-left: -20px;
`;

/**
 * @oaram {string} className
 */
const StyledNekoPage = props => {

  const { className, children, style = {} } = props;

  return (
    <Page className={className || ''} style={style}>
      {children}
    </Page>
  );
};

const NekoPage = (props) => {
  return (<StyledNekoPage {...props} />);
}

NekoPage.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

NekoPage.defaultProps = {
  className: undefined,
  style: {}
};

export { NekoPage };
